import mitt from 'mitt';

const emitter = mitt();

export const EVENTS = {
    APP_ROLES_MAPPING_UPDATED: 'APP_ROLES_MAPPING_UPDATED',
};

export default emitter;
